<template>
  <div class="cp-set-email main">
    <div class="divider" />

    <div class="row">
      <p>
        <i class="fa fa-mobile-alt icon" />Mobile Banner
        <span class="required has-text-primary">Required</span>
        <span class="has-text-grey is-pulled-right">Short</span>
      </p>
      <p
        class="banner has-bg-img"
        :class="{ tile: bannerStyle === 'tile' }"
        v-webp:bg="bannerPicURL"
        @click="setPic('mobile')"
      >
        <!-- <img :src="bannerPicURL" /> -->
      </p>
      <p class="has-text-grey has-text-right" style="margin-top: 10px">Tall</p>
      <p
        class="banner tall has-bg-img"
        :class="{ tile: bannerStyle === 'tile' }"
        v-webp:bg="bannerPicURL"
        @click="setPic('mobile')"
      >
        <!-- <img :src="bannerPicURL" /> -->
      </p>
      <p class="has-text-grey" style="margin-left: 8px; margin-top: 8px">
        The banner image appears short on your menu and tall on your business
        info page. Recommended dimensions: width 500px, height 200px
      </p>
      <div class="save-wrapper">
        <p class="button has-text-success" @click="setPic('mobile')">
          <span>Change</span>
        </p>
      </div>
    </div>

    <div class="divider" />

    <div class="row">
      <p>
        <i class="fa fa-laptop icon" />Desktop Banner
        <span class="required has-text-info">Optional</span>
        <span class="is-pulled-right" @click="deleteDesktopBanner">
          <i class="far fa-trash-alt has-text-grey" />
        </span>
      </p>
      <!-- v-webp:bg="desktopBannerPicURL" -->
      <div style="margin-top: 10px" @click="setPic('desktop')">
        <p v-if="desktopBannerPicURL" class="desktop-banner">
          <img :src="desktopBannerPicURL" />
        </p>
        <p v-else>
          <img src="https://via.placeholder.com/1200x600.png?text=1200x600" />
        </p>
      </div>
      <p class="has-text-grey" style="margin-left: 8px">
        Desktop banner image shows on wide screen devices. Recommended
        dimensions: width 1200px, height 600px
      </p>
      <div class="save-wrapper">
        <p class="button has-text-success" @click="setPic('desktop')">
          <span>Change</span>
        </p>
      </div>
    </div>

    <div class="divider" />
    <div class="row">
      <p><i class="fa fa-tshirt icon" />Banner Style</p>
      <p class="value">
        <span v-if="bannerStyle">{{ bannerStyle }}</span>
        <span v-else>Set Banner Style</span>
      </p>
      <p v-if="showStyleSelector" style="margin-left: 32px; margin-top: 8px">
        <span :class="btn" @click="setStyle('cover')"
          ><i class="fa fa-square" />&nbsp;Cover</span
        >&nbsp;
        <span :class="btn" @click="setStyle('tile')"
          ><i class="fa fa-th-large" />&nbsp;Tile</span
        >&nbsp;
        <span v-if="updatingStyle" :class="btn"
          ><i class="fa fa-spinner fa-spin"
        /></span>
      </p>
      <div class="save-wrapper">
        <p
          v-if="showStyleSelector"
          class="button is-light"
          @click="showStyleSelector = false"
        >
          <span>Cancel</span>
        </p>
        <p
          v-else
          class="button has-text-success"
          @click="showStyleSelector = true"
        >
          <span>Change</span>
        </p>
      </div>
    </div>
    <div style="height: 200px" />

    <input
      type="file"
      ref="file"
      style="display: none"
      accept="image/png,image/jpeg,image/jpg,image/bmp"
      @change="setPicAWS($event)"
    />
  </div>
</template>


<script>
import imageCompression from "browser-image-compression";

export default {
  name: "CPSetBannerImage",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      updatingStyle: false,
      showStyleSelector: false,
      btn: "button is-small is-rounded",
      imageType: "mobile", // mobile or desktop
      smallOptions: { maxSizeMB: 0.35, maxWidthOrHeight: 800 },
      bigOptions: { maxSizeMB: 0.7, maxWidthOrHeight: 1200 },
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    desktopBannerPicURL() {
      return this.business.data.desktop_banner_pic_url;
    },
    bannerPicURL() {
      return this.business.banner_pic_url;
    },
    bannerStyle() {
      return this.business.data.banner_style;
    },
    compressOptions() {
      var opts = this.smallOptions;
      if (this.imageType === "desktop") opts = this.bigOptions;
      opts.useWebWorker = true;
      return opts;
    },
  },
  mounted() {
    if (!this.bannerStyle) this.showStyleSelector = true;
  },
  methods: {
    deleteDesktopBanner() {
      var obj = { id: this.business.id };
      obj.data = { desktop_banner_pic_url: null };
      this.$store
        .dispatch("updateBusiness", obj)
        .then((res) => {
          this.business.data = res.data.data;
          this.successToast("Success!");
        })
        .catch((err) => this.apiError(err));
    },
    setPic(type) {
      var msg = `Opening file selector <i class='fa fa-spinner fa-spin'></i>`;
      this.infoToast(msg, "top", 2000);
      this.imageType = type;
      this.$refs.file.click();
    },
    setStyle(style) {
      var obj = { banner_style: style };
      this.updatingStyle = true;
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: obj,
        })
        .then((res) => {
          this.successToast("Updated!");
          this.business.data = res.data.data;
          this.showStyleSelector = false;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingStyle = false));
    },
    save() {
      // check name has minimum chars
      // save shop name
    },
    savePicURL(picURL) {
      var obj = { id: this.business.id };
      if (this.imageType === "mobile") {
        obj.banner_pic_url = picURL;
      } else {
        obj.data = { desktop_banner_pic_url: picURL };
      }
      this.$store
        .dispatch("updateBusiness", obj)
        .then((res) => {
          if (this.imageType === "mobile")
            this.business.banner_pic_url = picURL;
          else this.business.data = res.data.data;
          this.successToast("Success!");
        })
        .catch((err) => this.apiError(err));
    },
    setPicAWS(e) {
      if (!e.target.files) return;
      if (!e.target.files.length) return;
      var originalFile = e.target.files[0];

      var loader = this.loadingDots();

      imageCompression(originalFile, this.compressOptions)
        .then((compressedFile) => {
          var sizeKB = Math.round(compressedFile.size / 1024);
          this.console(`compressedFile size ${sizeKB} KB`); // smaller than maxSizeMB

          imageCompression
            .getDataUrlFromFile(compressedFile)
            .then((base64) => {
              var data = {
                name: this.$shortid.generate() + ".png",
                content: base64.replace(/^data:image\/[a-z]+;base64,/, ""),
                businessID: this.business.id,
                imageType: this.imageType,
              };
              this.$store
                .dispatch("uploadImageAWS", data)
                .then((res) => {
                  console.log("uploadImageAWS", res.data);
                  var newPicURL = res.data.compressed_image_url;
                  this.savePicURL(newPicURL);
                })
                .catch((err) => this.apiError(err))
                .finally(() => loader.hide());
            })
            .catch((err) => this.console("imageData error", err));
        })
        .catch((err) => this.console("imageCompression error", err));
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  /* border-bottom: 1px dotted rgb(230, 230, 230); */
  text-transform: capitalize;
}
.save-wrapper {
  margin-top: 10px;
  text-align: right;
}
.has-bg-img {
  background-color: gold;
  background-size: cover;
  background-position: center;
}
/* .banner img { */
.banner {
  object-fit: cover;
  height: 100px;
  width: 100%;
  margin-top: 10px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.14);
}
.desktop-banner img {
  width: 100%;
}
.tile img {
  object-fit: contain;
}
.tall img {
  height: 200px;
}
.tall {
  height: 200px;
}
.full,
.full img {
  height: initial;
}
.tile {
  background-size: contain;
}
.required {
  font-size: 0.8em;
  font-weight: 500;
  opacity: 0.8;
}
</style>
